class PclGlobalHeader extends HTMLElement {
    constructor() {
        super();
        this.header$;
        this.menuBtn$
        this.cruiseDealsLocalizedContent = `
            data-us-url="/cruise-deals-promotions/"
            data-us-text="Cruise Deals"
            data-uk-url="/cruise-deals-promotions/uk/" 
            data-uk-text="Cruise Deals" 
            data-gb-url="/cruise-deals-promotions/uk/" 
            data-gb-text="Cruise Deals"
            data-au-url="/cruise-deals-promotions/au/" 
            data-au-text="Cruise Deals" 
            data-nz-url="/cruise-deals-promotions/au/" 
            data-nz-text="Cruise Deals"
            data-hk-url="/static/html/global/cruisedeals/hk/top-deals/index.html" 
            data-hk-text="Cruise Deals"
            data-sg-url="/static/html/global/cruisedeals/sin/top-deals/index.html" 
            data-sg-text="Cruise Deals"
            data-my-url="/static/html/global/cruisedeals/sin/top-deals/index.html"
            data-my-text="Cruise Deals" 
            data-id-url="/static/html/global/cruisedeals/sin/top-deals/index.html"
            data-id-text="Cruise Deals"
            data-bn-url="/static/html/global/cruisedeals/sin/top-deals/index.html"
            data-bn-text="Cruise Deals"
            data-vn-url="/static/html/global/cruisedeals/sin/top-deals/index.html"
            data-vn-text="Cruise Deals"
            data-track="header"
            data-track-id="Cruise Deals">`;
        this.locale = (window.localeData?.status)?.toLowerCase() || 'in';
        this.cruiseButtonHref = '/cruise-search/cruises';
    }

    connectedCallback() {
        const template = document.createElement('template');
        template.innerHTML = `<div id="pcl-global-header"></div>`
        this.attachShadow({ mode: "open" }).appendChild(
            template.content.cloneNode(true)
        );

        this.init();
    }

    init() {
        this.pclLang = docCookies.getItem("pcl_lang") || 'en';

        if (this.shadowRoot.querySelector('#pcl-global-header')) {
            window.addEventListener('resize', () => {
                const resizedViewport = window.getViewportDimensions();
                if(resizedViewport.width < 767) {
                    this.checkAppSection();
                }
            });

            /**
             * All Booking Team projects (booking engine, vertical deck plans, and affiliates portal)
             * import their own versions of these stylesheets. This logic causes multiple stylesheet adds.
             */
            const bookingProjectsUrls = ['cruise-search', 'deckPlans', 'affiliates', 'localhost'];
            const isBookingPage = this.getAttribute('booking') === 'true' ||
                bookingProjectsUrls.some(url => window.location.href.includes(url));

            // Set stylesheet paths based on booking page condition
            const pclGlobalHeaderCSS = isBookingPage
                ? `${$wwwURL}/assetroot/css/global/web-components/booking/pcl-global-header.css`
                : `${$wwwURL}/assetroot/css/global/web-components/pcl-global-header/pcl-global-header.css`;
            const princessNormalizeCSS = isBookingPage
                ? `${$wwwURL}/assetroot/css/global/booking/princess-normalize.css`
                : `${$wwwURL}/assetroot/css/global/princess-normalize.css`

            this.linkStylesheet(pclGlobalHeaderCSS)
                .then(() => {
                    const linkElem = document.createElement("link");
                    linkElem.setAttribute("rel", "stylesheet");
                    linkElem.setAttribute("href", pclGlobalHeaderCSS);
                    this.shadowRoot.prepend(linkElem);
                })
                .catch(() => console.error("pcl-global-header.css could not be loaded"))
                .then(() => {
                    return this.linkStylesheet(princessNormalizeCSS);
                })
                .then(() => {
                    const normalize = document.createElement("link");
                    normalize.setAttribute("rel", "stylesheet");
                    normalize.setAttribute("href", princessNormalizeCSS);
                                this.shadowRoot.prepend(normalize);
                            }).then(() => {
                                this.buildTemplate();
                                this.render();

                })
                .catch((err) => console.error("Error loading stylesheets:", err));
        }
    }

    render() {
        // Init Element & Variables
        this.header$ = this.shadowRoot.querySelector(".global-header");
        this.menuBtn$ = this.header$.querySelector('.global-header__menu-btn');
        this.hamburgerMenu$ = this.shadowRoot.querySelector(".global-header__nav-container");
        this.headerOverlay$ = this.shadowRoot.querySelector(".global-header__nav-container-overlay");
        this.loginLink$ = this.shadowRoot.querySelectorAll('.my-account-login');
        this.logoutBtn$ = this.shadowRoot.querySelectorAll('.my-account-logout-btn');

        // Search
        this.search$ = this.shadowRoot.querySelector('.global-header__search');
        this.searchDropdown$ = this.shadowRoot.querySelector('.global-header__search-dropdown');
        this.searchDropdownBtn$ = this.shadowRoot.querySelector('.global-header__search-btn');
        this.searchDropdownContent$ = this.shadowRoot.querySelector('.global-header__search-dropdown-content');
        this.searchBtn$ = this.shadowRoot.querySelector('.global-header__searchbar-button');
        this.searchBtnMobile$ = this.shadowRoot.querySelector('.global-header__searchbar-button-mobile');
        this.searchInput$ = this.shadowRoot.querySelector('.global-header__searchbar-input');
        this.searchInputMobile$ = this.shadowRoot.querySelector('.global-header__searchbar-input-mobile');
        this.searchCloseBtn$ = this.shadowRoot.querySelector('.global-header__search-close');
        this.specialOffersLink$ = this.shadowRoot.querySelector('.special-offers-sign-up');
        this.ownidLink$ = this.shadowRoot.querySelector('#ownid-link a'),

        // Language Selector
        this.languageSelector$ = this.shadowRoot.querySelector('.global-header__language-selector');
        this.languageSelectorBtn$ = this.shadowRoot.querySelector('.global-header__language-selector-btn');
        this.languageSelectorDropdown$ = this.shadowRoot.querySelector('.global-header__language-dropdown');

        if (this.shadowRoot) {
            let headerElement = this.shadowRoot.querySelector('.global-header');
            let headerElementPosition = headerElement.offsetTop;
            window.addEventListener('scroll', () => {
                if (window.scrollY > headerElementPosition ) {
                    headerElement.classList.add('fixed');
                } else {
                    headerElement.classList.remove('fixed');
                }
            });
        }

        let viewportDimensions = window.getViewportDimensions();
        this.updateLogoutButtons();

        // Init Event Listeners
        this.menuBtn$.addEventListener('click', (e) => {
           e.preventDefault();
           this.handleMenuOpenClose();
        });

        this.menuBtn$.addEventListener('keydown', (e) => {
            if (e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault();
                this.handleMenuOpenClose();
            }
        });

        this.headerOverlay$.addEventListener('click', () => {
            this.closeMenu();
        });

        if (this.logoutBtn$) {
            Array.from(this.logoutBtn$).forEach(logoutBtn => {
                logoutBtn.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.closeMenu(); // close mobile menu
                    isOwnId = logoutBtn.classList.contains("ownid");
                    window?.guestAuth.logout(false, false, isOwnId);
                    },{once: true});
            });
        }

        // Handle Search Close & Language Dropdown Close
        if(viewportDimensions.width < 767) {
            this.checkAppSection();
        }

        if (viewportDimensions.width > 767) {
            this.shadowRoot.addEventListener('click', (e) => {
                // Handle search modal closing - only if search is enabled
                if (this.getAttribute('search') !== 'false' && this.searchDropdownContent$ && this.searchDropdownBtn$ && this.searchCloseBtn$) {
                    const isclickedOnDropdown = this.searchDropdownContent$.contains(e.target);
                    const isclickedOnSearchBtn = this.searchDropdownBtn$.contains(e.target);
                    const isClickedOnSearchClose = this.searchCloseBtn$.contains(e.target)
                    if ((!isclickedOnSearchBtn && !isclickedOnDropdown) || isClickedOnSearchClose) {
                        this.closeSearchModal();
                    }
                }

                // Handle language dropdown closing
                if (this.languageSelectorDropdown$ && this.languageSelectorBtn$) {
                    const isClickedOnLangDropdown = this.languageSelectorDropdown$ && this.languageSelectorDropdown$.contains(e.target);
                    const isclickedOnLangBtn = this.languageSelectorBtn$ && this.languageSelectorBtn$.contains(e.target);
                    if (!isClickedOnLangDropdown && !isclickedOnLangBtn) {
                        this.closeLanguageDropdown();
                    }
                }
            });
        }

        // Language Dropdown Close when clicked anywhere on the screen except global header
        document.addEventListener('click', (e) => {
            if (e.target.nodeName === 'PCL-GLOBAL-HEADER') {
                return;
            } else if (this.languageSelectorDropdown$) {
                this.closeLanguageDropdown();
            }
        });

        // Search-related event listeners - only attach if search elements exist
        if (this.getAttribute('search') !== 'false') {
            // Handle Search Open - Mouse click
            if (this.searchDropdownBtn$) {
                this.searchDropdownBtn$.addEventListener('click', () => {
                    this.openSearchModal();
                    this.searchInput$ && this.searchInput$.focus();
                });

                // Handle Search Open - Keyboard events
                this.searchDropdownBtn$.addEventListener('keydown', (e) => {
                    if (e.keyCode === 13 || e.keyCode === 32) {
                        this.openSearchModal();
                        this.searchInput$ && this.searchInput$.focus();
                    }
                });
            }

            // Handle Search Close - Keyboard events
            if (this.searchCloseBtn$) {
                this.searchCloseBtn$.addEventListener('keydown', (e) => {
                    if (e.keyCode === 13 || e.keyCode === 32) {
                        this.closeSearchModal();
                        this.searchDropdownBtn$ && this.searchDropdownBtn$.focus();
                    }
                });
            }

            // Desktop - Handle Search on click search icon next to search input
            if (this.searchBtn$ && this.searchInput$) {
                this.searchBtn$.addEventListener('click', () => {
                    this.handleSearch(this.searchInput$.value);
                });
            }

            // Mobile - Handle Search on click search icon next to search input
            if (this.searchBtnMobile$ && this.searchInputMobile$) {
                this.searchBtnMobile$.addEventListener('click', () => {
                    this.handleSearch(this.searchInputMobile$.value);
                });
            }

            // Desktop - Handle Search on keyboard enter for search input
            if (this.searchInput$) {
                this.searchInput$.addEventListener('keydown', (e) => {
                    if (e.keyCode === 13) {
                        this.handleSearch(this.searchInput$.value);
                    }
                });
            }

            // Mobile - Handle Search on keyboard enter for search input
            if (this.searchInputMobile$) {
                this.searchInputMobile$.addEventListener('keydown', (e) => {
                    if (e.keyCode === 13) {
                        this.handleSearch(this.searchInputMobile$.value);
                    }
                });
            }
        }

        // Toggle language dropdown
        if (this.languageSelectorBtn$ && this.languageSelector$) {
            this.languageSelectorBtn$.addEventListener('click', () => {
                if (this.languageSelector$.classList.contains('active')) {
                    this.closeLanguageDropdown();
                } else {
                    this.openLanguageDropdown();
                }
            });
        }

        // Set pcl_lang cookie with selected language
        if (this.languageSelectorDropdown$) {
            this.languageSelectorDropdown$.addEventListener('click', (e) => {
                const selectedLanguage = e.target.getAttribute('data-language-select');
                if (selectedLanguage) {
                    const languageCode = selectedLanguage.split('|');
                    this.languageSelectorDropdown$.querySelectorAll('a').forEach((languageLink) => {
                        languageLink.classList.remove('active');
                    });

                    this.languageSelectorDropdown$.querySelector(`a[data-language-select='${selectedLanguage}']`).classList.add('active');
                    docCookies.setItem('pcl_lang', languageCode[0], 31536000, '/', 'princess.com', true);
                }
            });
        }

        // close Menu when browser width is resized
        window.addEventListener('resize', () => {
            const resizedViewport = window.getViewportDimensions();
            if (resizedViewport.width !== viewportDimensions.width) {
                this.closeMenu();
            }
            viewportDimensions = window.getViewportDimensions();
        });

        if(this.loginLink$) {
            Array.from(this.loginLink$).forEach(loginLink => {
                const isOwnID = loginLink.classList.contains('ownid');
                if(isOwnID || this.getAttribute('login-in-modal') === 'true'){
                loginLink.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.closeMenu(); // close mobile menu
                    const isOwnID = loginLink.href.includes('/ownid/')
                    window.dispatchEvent(new CustomEvent('web-component.onClick', {
                        detail: {
                            src: loginLink.href,
                            type: 'iframe',
                            mainClass: ["mfp-entry-point" , isOwnID? "mfp-entry-point-ownid": "mfp-entry-point-login"].join(' ')
                        }
                    }));
                });
            }
            });
        }

        if(this.getAttribute('min-width')) {
            this.shadowRoot.querySelector('header').style.minWidth = this.getAttribute('min-width');
        }

        if (this.specialOffersLink$) {
            this.specialOffersLink$.addEventListener('click', (event) => {
                event.preventDefault();
                window.dispatchEvent(new CustomEvent('web-component.onClick', {
                    detail: {
                        src: this.specialOffersLink$.href,
                        type: 'iframe',
                        mainClass: "special-offers"
                    }
                }));
            });
        }
        // this.ownidLink$.addEventListener('click', event => {
        //   event.preventDefault();
        //   this.closeMenu();
        //   window.dispatchEvent(new CustomEvent('web-component.onClick', {
        //     detail: {
        //       src: this.ownidLink$.href,
        //       type: 'iframe',
        //       mainClass: 'mfp-entry-point-ownid'
        //     }
        //   }));
        // }),       
        window.addEventListener('web-component.setFocus', (event) => {
            const selector = event.detail.elementSelector;
            this.shadowRoot.querySelector(selector) && this.shadowRoot.querySelector(selector).focus();
        })

        if(this.languageSelectorDropdown$) {
            window.setupLanguageSelector(this.languageSelectorDropdown$);
        }
    }

    /**
     * List of attribues to watch changes for global header
     */
    static get observedAttributes() {
        return ['language', 'search', 'cruise-deals', 'special-offers', 'my-account', 'custom-message', 'global-nav', 'guest-auth'];
    }

    /**
     * Triggered when attributes are added, modified or removed
     * @param {string} name - name of the attribute
     * @param {string} oldValue - old value of the attribute
     * @param {string} newValue - new value of the attribute
     */
    attributeChangedCallback(name, oldValue, newValue) {
        if (this.shadowRoot && oldValue !== newValue) {
            switch (name) {
                case 'custom-message':
                    const customMessage = this.shadowRoot.querySelector('[data-observed-attr="custom-message"]');
                    customMessage.classList.remove('hidden');
                    customMessage.innerHTML = newValue;
                    break;
                case 'guest-auth':
                    // rebuild entire header when guest-auth is updated
                    this.buildTemplate();
                    // reinitialize event listeners - not ideal, can be removed if event delegation used
                    this.render();
                    window.savedCruiseCount.load();
                    break;
                default:
                    const observedElements = this.shadowRoot.querySelectorAll(`[data-observed-attr='${name}']`);
                    observedElements.forEach((element) => {
                        if (newValue === 'true') {
                            element.classList.remove('hidden');
                        } else {
                            element.classList.add('hidden');
                        }
                    });
            }
        }
    }

    /**
     * Get login src based on the current url path.
     * Handles Shopping Flow, Brochures, and Cruise Personalizer, and for all other pages set current page path as src
     * @returns login src path
     */   
    getLoginSrc() {
        const currentPath = window.location.pathname;
        let src = '?src=';

        if (currentPath.startsWith('/cruise-search/')) {
            src += 'cruise-search';
        } else if (currentPath.startsWith('/brochures/')) {
            src +=  'brochures';
        } else if (currentPath.startsWith('/cruisepersonalizer/') || currentPath.startsWith('/manage-booking/')) {
            src +=  'cruisepersonalizer';
        } else if (currentPath.startsWith('/my-princess/')) {
            src += 'my-princess';
        } else {
            src += encodeURIComponent(window.location.href);
        }
        return src;
    }

    /**
     * Open Search Modal
     */
    openSearchModal() {
        if (this.searchDropdown$) {
            document.documentElement.style.overflow = 'hidden';
            this.searchDropdown$.classList.remove('hidden');
            this.searchDropdown$.removeAttribute('aria-hidden', 'false');
        }
    }

    /**
     * Close Search Modal
     */
    closeSearchModal() {
        if (this.searchDropdown$) {
            document.documentElement.style.overflow = 'auto';
            this.searchDropdown$.classList.add('hidden');
            this.searchDropdown$.setAttribute('aria-hidden', 'true');
        }
    }

    /**
     * Handle Search
     */
    handleSearch(value) {
        if (value) {
            window.location.href = `${$wwwURL}/search/#stq=${value}`;
        }
    }

    /**
     * Open Language Dropdown
     */
    openLanguageDropdown() {
        if (this.languageSelector$) {
            this.languageSelector$.classList.add('active');
        }
        if (this.languageSelectorDropdown$) {
            this.languageSelectorDropdown$.classList.remove('hidden');
        }
    }

    /** Close Language Dropdown */
    closeLanguageDropdown() {
        if (this.languageSelector$) {
            this.languageSelector$.classList.remove('active');
        }
        if (this.languageSelectorDropdown$) {
            this.languageSelectorDropdown$.classList.add('hidden');
        }
    }

    /**
     * Close Menu and dispatch closedrawer event to global-nav
     */
    closeMenu() {
        this.menuBtn$.classList.remove('expanded');
        window.setTimeout(() => {
            this.header$.classList.remove('menu-expanded');
        }, 300);
        this.hamburgerMenu$.classList.remove('menu-expanded');
        document.querySelector('body').style.overflow = 'auto';
        document.querySelector('html').style.overflow = 'auto';
        window.dispatchEvent(new CustomEvent('pcl-global-nav.closedrawer'));
        this.menuBtn$.setAttribute('aria-expanded', "false");
        this.menuBtn$.setAttribute('aria-label', "Menu Collapsed");
    }

    checkAppSection() {
       const pathName = window.location.pathname;
        if(pathName === '/cruise-search/search') {
            this.shadowRoot.querySelector('#pcl-global-header').classList.add('menu-mobile');
        } else {
            this.shadowRoot.querySelector('#pcl-global-header').classList.remove('menu-mobile');
        } 
    }

    handleMenuOpenClose() {
        if (!this.menuBtn$.classList.contains('expanded')) {
            this.header$.classList.add('menu-expanded');
            this.hamburgerMenu$.classList.add('menu-expanded');
            this.menuBtn$.classList.add('expanded');
            this.menuBtn$.setAttribute('aria-expanded', "true");
            this.menuBtn$.setAttribute('aria-label', "Menu Expanded");
            document.querySelector('body').style.overflow = 'hidden';
            document.querySelector('html').style.overflow = 'hidden';
            window.dispatchEvent(new CustomEvent('pcl-global-nav.opendrawer'));
        } else {
            this.closeMenu();
        }
    }

    updateLogoutButtons() {
        const isOwnIdEnabled = docCookies.getItem('isOwnIdEnabled');
        this.shadowRoot.querySelectorAll('.my-account-logout-btn')
     .forEach(btn => {
       const isLegacy = btn.classList.contains("legacy");
       const isOwnId  = btn.classList.contains("ownid");
        if (isOwnIdEnabled === 'true') {
         if (isLegacy) btn.classList.add("hidden");
         if (isOwnId)  btn.classList.remove("hidden");
       } else {
         if (isLegacy) btn.classList.remove("hidden");
         if (isOwnId)  btn.classList.add("hidden");
       }
     });		
    } 

    buildTemplate() {
        const attributes = [`data-${this.locale}-url`, `data-${this.locale}-text`];
		const attributesData = window.getAttributesFromLink(this.cruiseDealsLocalizedContent, attributes);
		const cruiseDealslocalizedLinkUrl = attributesData[0];
		const cruiseDealslocalizedLinkTitle = attributesData[1];
        const isGuestAuthenticated = this.getAttribute('guest-auth') === 'true';

        this.shadowRoot.querySelector('#pcl-global-header').innerHTML = /*html*/`
            <pcl-system-outage></pcl-system-outage>
            <header class="global-header">
                <div class="global-header__container">
                    <div class="global-header__container-left">
                        <a href="#content" id="skip-to-content" class="global-header__container-skip-link" data-track="header" data-track-id="Skip to main content">Skip to main content</a>
                        <a class="invert-decoration global-header__logo-desktop" href="${$wwwURL}" data-track="header" data-track-id="princess-logo">
                            <svg class="pcl-logo-seawitch" id="pcl-logo-seawitch" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="76" height="35" viewBox="0 0 76 35"><title>pcl-logo-seawitch</title><path d="M73.863,32.1a1.314,1.314,0,0,1,0,2.627,1.314,1.314,0,0,1,0-2.627Zm0,2.421a1.1,1.1,0,1,0-1.093-1.1A1.073,1.073,0,0,0,73.867,34.525Zm.235-.972.364.58h-.274l-.343-.554h-.241v.554h-.231V32.715h.606a.411.411,0,0,1,.423.415v.063A.361.361,0,0,1,74.1,33.553Zm-.494-.164h.345a.209.209,0,0,0,.229-.184v-.067a.229.229,0,0,0-.229-.21h-.345Z"/><path d="M28.88,24.231C37,25.591,42.13,15.125,49.8,18.72c8.122,3.81,18.169,10.071,25.364-2.987a10.9,10.9,0,0,1-6.605,1.52c-6.686-.9-11.988-9.341-21.688-2.985-7.533,4.939-8.765,5.324-17.83-.25l-.014-.011h0a1.156,1.156,0,0,0-.185-.125c-.7-.289-1.088-.057-.913.709.19.825.964,5.481.964,5.481s.348.9-.442,1.036a5.349,5.349,0,0,1-.84.049c-.371.069-1.111.2-.546,1.238.161.253.234,1-1.155,1.174-.273.033-.325.33-.151.429s.693.167.765.4c.084.256.05.493-.334.8-.233.188-.516.282-.479.561s.4.486.2,1.364a1.041,1.041,0,0,1-.893.8c-.424.063-4.485-.2-5.231-.209-2.543-.038-4.016,3.413-4.965,6.038a.251.251,0,0,0,.068.026c8.228,2.477,17.2-.259,23.974-3.541,7.759-3.755,9.627-1.761,13.077-.168,4.381,2.018,14.888,11.245,23.114-3.679A10.924,10.924,0,0,1,68.446,27.9c-6.433-.868-12.094-9.673-22.073-3.134-4.131,2.71-8.107,5.653-17.7-.244C28.5,24.414,28.64,24.176,28.88,24.231Z"/><path d="M68.817,6.154c-8.209-1.109-12.692-8.065-21.458-2.32-5.337,3.5-7.344,6.43-17.9-.06A29.155,29.155,0,0,0,18.033.02,17.133,17.133,0,0,0,.021,16.406,16.37,16.37,0,0,0,5.115,29.433a.683.683,0,0,0,1.124-.15l.1-.235,5.417-13.037s2.936-7.666,10.183-5.271c2.333.77,4.259,1.516,5.992,2.044,4.132,1.264,7.159,1.293,11.937-2.5,2.173-1.727,5.767-4.137,10.421-1.994,6.512,3,17.386,10.413,25.139-3.65A10.942,10.942,0,0,1,68.817,6.154Z"/></svg>   
                            <svg class="pcl-logo" id="pcl-logo" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="295" height="35" viewBox="0 0 295 35"><title>Princess Cruises Logo Mark</title><path d="M28.827,13.89c9.057,5.568,10.491,5.327,18.017.385,9.7-6.357,15,2.088,21.679,2.989a10.9,10.9,0,0,0,6.6-1.52c-7.189,13.051-17.232,6.8-25.35,2.98-7.667-3.589-12.793,6.873-20.9,5.514-.243-.052-.387.183-.208.293,9.586,5.888,13.561,2.948,17.689.239,9.976-6.535,15.634,2.266,22.066,3.133a10.879,10.879,0,0,0,6.6-1.518c-8.22,14.92-18.724,5.7-23.1,3.679-3.455-1.589-5.321-3.584-13.075.167-6.774,3.288-15.743,6.014-23.967,3.543a.3.3,0,0,1-.067-.028c.95-2.625,2.421-6.073,4.965-6.035.743,0,4.8.271,5.226.208a1.041,1.041,0,0,0,.894-.792c.2-.879-.162-1.083-.2-1.368s.246-.373.479-.564c.383-.307.418-.538.334-.8-.074-.223-.591-.295-.764-.392s-.123-.394.152-.429c1.386-.183,1.312-.919,1.154-1.179-.567-1.027.315-1.21.642-1.288.44-.1,1.237-.407,1.006-1.182-.279-.932-.549-1.62-.741-2.42-.307-1.286-.63-2.418-.326-3.158.4-.973.815-.7,1.2-.46"/><path d="M68.787,6.169C60.578,5.061,56.1-1.892,47.333,3.847,42,7.348,40,10.281,29.441,3.791,24.162.543,21.018.231,18.018.036a17.015,17.015,0,0,0-18,16.377A16.378,16.378,0,0,0,5.108,29.439a.686.686,0,0,0,1.126-.155l.1-.235,5.416-13.031s2.935-7.658,10.176-5.264c2.33.762,4.255,1.513,5.986,2.039,4.135,1.269,7.161,1.294,11.936-2.5C42.019,8.565,45.609,6.152,50.264,8.3c6.51,2.993,17.38,10.41,25.132-3.646A10.969,10.969,0,0,1,68.787,6.169Z"/><path d="M290.161,3.745a2.423,2.423,0,1,1,2.412,2.3A2.3,2.3,0,0,1,290.161,3.745Zm4.339-.012a1.921,1.921,0,0,0-3.839-.013,1.92,1.92,0,0,0,3.839.013Zm-2.918-.378,0-.657c0-.158-.1-.184-.315-.185-.026,0-.053-.027-.053-.079,0-.079.054-.1.132-.1h.106c.052,0,.262.028.446.028.237,0,.342-.025.6-.024.448,0,1.157.083,1.155.714,0,.263-.107.473-.555.787l.471.554c.341.4.394.4.446.4a.07.07,0,0,1,.079.079c0,.079-.027.1-.237.1a1.024,1.024,0,0,1-1.024-.5l-.367-.5h-.315V4.2c0,.473.025.526.05.552a.82.82,0,0,0,.264.028c.052,0,.079,0,.078.078a.1.1,0,0,1-.105.106h-.105c-.053,0-.29-.027-.421-.028-.079,0-.342.026-.395.026h-.131c-.053,0-.184-.027-.184-.106a.069.069,0,0,1,.079-.078c.237,0,.263,0,.29-.157a5.458,5.458,0,0,0,0-.684Zm.578.265a.843.843,0,0,0,.368.081.4.4,0,0,0,.237-.052A.512.512,0,0,0,293,3.2a.573.573,0,0,0-.6-.58c-.026,0-.184,0-.237.052Z"/><path d="M97.64.73c-.925,0-1.972.027-2.988.055-.947.028-1.87.053-2.636.051-.451,0-1.14-.024-1.94-.052C88.958.743,87.633.7,86.436.692c-.976,0-1.474.33-1.476.988,0,.3.122.993,1.276,1a7.158,7.158,0,0,1,1.373.11c.842.2,1.114.469,1.183,1.8.069,1.308.065,2.446.044,8.759l-.025,7.3c-.013,3.788-.025,7.059-.218,8.755-.134,1.027-.289,1.679-.658,1.754a5.35,5.35,0,0,1-1.255.146c-1.149,0-1.242.725-1.243.946,0,.241.1,1.033,1.39,1.038.888,0,2.068-.036,3.084-.066.758-.023,1.422-.044,1.8-.042s.979.02,1.711.045c1.183.041,2.717.095,4.3.1,1,0,1.358-.551,1.359-1.028,0-.159-.056-.951-1.236-.955a15.092,15.092,0,0,1-1.892-.165c-.57-.084-.847-.349-.979-1.7-.181-1.751-.17-5.023-.157-8.811l.057-16.589a1.264,1.264,0,0,1,.018-.238,5.374,5.374,0,0,1,1.186-.093A4.925,4.925,0,0,1,99.526,5.2a7.631,7.631,0,0,1,2.074,5.784c-.013,3.8-2.731,6.213-4.6,6.207-.465,0-1.7-.006-1.709,1.069,0,.352.159.809.95.982a5.11,5.11,0,0,0,.945.06c5.884.02,10.17-4.448,10.191-10.622a8.007,8.007,0,0,0-2.1-5.375C104.656,2.675,102.761.748,97.64.73Z"/><path d="M188.707,1.042c-1.376-.005-2.539.051-3.289.085-.337.016-.587.026-.726.026-.329,0-.823-.02-1.427-.045-.97-.04-2.218-.092-3.529-.1-.5,0-1.686-.006-1.689.987,0,.3.121.994,1.271,1a6.452,6.452,0,0,1,1.931.2c.586.252.971.608,1,3.184l.324,17.266c-.529-.561-1.238-1.318-2.007-2.14-2-2.138-4.489-4.8-6.1-6.436C168.86,9.392,162.8,2.8,161.83,1.727l-.376-.415c-.531-.6-.952-1.07-1.588-1.073-1.149,0-1.154,1.523-1.156,2.017l-.453,24.549c-.051,3.43-.227,4.369-.838,4.557a6.534,6.534,0,0,1-1.675.175c-1.149,0-1.276.66-1.277.947,0,1.032,1.143,1.036,1.517,1.038,1.515.005,2.926-.053,3.757-.087.329-.016.565-.024.67-.023.267,0,.635.016,1.115.038.913.04,2.221.1,3.963.1,1.036,0,1.562-.344,1.564-1.027,0-.355-.17-.951-1.31-.955a5.933,5.933,0,0,1-1.923-.259c-.626-.227-.957-1.547-1.011-4.044l-.357-15.89c1.756,1.966,5.261,5.883,8.747,9.4,1.727,1.743,3.619,3.681,5.426,5.534,2.621,2.685,5.094,5.221,6.619,6.7a2.871,2.871,0,0,0,1.826,1.1c1.152,0,1.157-1.429,1.158-1.889l.538-26.166c.054-2.468.444-2.759,1.057-2.936a3.921,3.921,0,0,1,1.082-.1c1.256,0,1.358-.756,1.359-.989C190.268,1.047,189.093,1.043,188.707,1.042Z"/><path d="M219.532,24.787c-.888,0-1.035.769-1.139,1.313a6.367,6.367,0,0,1-1.257,2.461c-1.527,1.768-3.639,2.1-7.007,2.084-4.934-.016-12.218-4.536-12.185-14.188.016-4.755,1.156-8.023,3.59-10.276,1.807-1.659,4.048-2.392,7.26-2.381,3.887.014,6.729,1.215,7.826,2.4a5.367,5.367,0,0,1,1.409,3.4c0,1.016.341,1.533,1.019,1.536,1.01,0,1.082-1.072,1.112-1.509s.058-1.259.07-2.15c.014-.817.025-1.691.067-2.355.052-.857.119-1.373.16-1.719a5.07,5.07,0,0,0,.056-.6,1.121,1.121,0,0,0-1.163-1.114c-.615-.067-1.253-.2-1.934-.335-.663-.136-1.366-.28-2.126-.385a40.526,40.526,0,0,0-6-.441c-5.74-.019-9.975,1.416-13.328,4.517a16.3,16.3,0,0,0-5.011,11.8c-.018,5.306,1.741,9.585,5.222,12.712l0,0c3.553,3.159,8.261,4.707,14.386,4.728a23.922,23.922,0,0,0,7.587-.978,2.039,2.039,0,0,0,1.419-1.6,39.2,39.2,0,0,0,.944-5.685C220.519,24.85,219.7,24.788,219.532,24.787Z"/><path d="M242.512,26.276c-.831,0-.968.794-1.028,1.143-.276,1.741-.712,2.276-1.371,2.608a8.349,8.349,0,0,1-3.25.418c-3.683-.013-3.823-.516-3.877-2.9-.023-.854,0-3.013.01-4.7l.028-4.783c1.37.013,4.292.068,4.86.136,1.188.145,1.456.637,1.567,1.137a7.054,7.054,0,0,1,.11,1.027l.022.338a.922.922,0,0,0,.953.994c.632,0,.958-.471.961-1.4,0-.153.033-.692.072-1.285.033-.522.066-1.08.085-1.449.1-1.384.2-2.139.261-2.561a4.693,4.693,0,0,0,.053-.508.878.878,0,0,0-.877-.956c-.476,0-.75.343-1.083.768-.174.212-.549.316-1.383.389-.511.05-2.543.071-5.593.061l.038-10.124c1.251.019,4.372.1,4.891.176,1.71.23,1.847.631,2.013,1.105a4.258,4.258,0,0,1,.18,1.275c0,1.08.666,1.2.955,1.2.244,0,.829-.094.988-.981.052-.332.106-1.234.148-1.946.022-.369.04-.684.054-.845a18.229,18.229,0,0,1,.252-2.238,3.268,3.268,0,0,0,.061-.494.863.863,0,0,0-.842-.993,1.625,1.625,0,0,0-.576.129,1.467,1.467,0,0,1-.185.056c-.292.078-1.01.167-1.487.225-.437.021-3.936.023-9.355,0-.476,0-1.237-.036-2.108-.079l-.255-.012c-.457,0-.948-.012-1.45-.025-.527-.013-1.069-.026-1.591-.028-.956,0-1.446.33-1.448.988,0,.3.122.994,1.254,1a6.573,6.573,0,0,1,1.321.109c.808.193,1.069.466,1.135,1.8.066,1.311.062,2.449.041,8.762l-.025,7.3c-.013,3.788-.024,7.059-.212,8.758-.125,1-.278,1.679-.63,1.754a5.063,5.063,0,0,1-1.2.143c-1.132,0-1.223.725-1.224.947,0,.241.1,1.033,1.367,1.037.372,0,.8-.017,1.237-.035s.917-.04,1.382-.041c.888-.037,1.7-.034,2.106-.032h0c1.118,0,2.276.05,3.893.138l1.143.035c1.427.044,3.166.1,5.365.109,1.45,0,2.25.008,2.632-1.546a35.94,35.94,0,0,0,.522-4.742C243.425,27.272,243.428,26.279,242.512,26.276Z"/><path d="M259.311,13.853l-1.137-.873c-3.45-2.673-4.078-3.949-4.073-5.495.008-2.222,1.678-3.649,4.257-3.64a4.61,4.61,0,0,1,4.886,4.168c0,1.231.713,1.367,1.022,1.368,1.07,0,1.074-1.3,1.076-1.858.008-2.275.092-3.523.143-4.266.023-.318.038-.545.039-.71,0-.394-.181-.905-1.026-1.1A20.316,20.316,0,0,0,258.9.7c-5.924-.02-10.075,3.444-10.092,8.424-.013,3.733,1.857,6.824,6.252,10.332l1.876,1.5c3.132,2.511,3.756,4.218,3.749,6.165,0,1.654-1.307,4.106-4.874,4.094a5.018,5.018,0,0,1-5.239-3.76,8.045,8.045,0,0,1-.336-1.945c0-1.194-.714-1.327-1.023-1.328-.664,0-1.038.555-1.115,1.673-.141,2.107-.218,3.943-.223,5.455,0,1.013.162,1.538,1.137,1.976a14.463,14.463,0,0,0,6.215,1.156,12.166,12.166,0,0,0,6.847-1.784,9.035,9.035,0,0,0,4.149-7.715C266.239,20.74,264.365,17.734,259.311,13.853Z"/><path d="M281.382,13.928l-1.137-.872c-3.45-2.673-4.078-3.949-4.073-5.5.008-2.221,1.678-3.648,4.257-3.639a4.608,4.608,0,0,1,4.886,4.167c0,1.232.713,1.367,1.022,1.368,1.07,0,1.074-1.3,1.076-1.857.008-2.276.092-3.524.142-4.267.024-.318.039-.544.04-.709,0-.394-.182-.906-1.026-1.1a20.324,20.324,0,0,0-5.6-.745C275.049.759,270.9,4.223,270.881,9.2c-.013,3.734,1.857,6.824,6.252,10.332l1.876,1.5c3.132,2.51,3.756,4.218,3.749,6.164,0,1.654-1.308,4.107-4.874,4.1a5.023,5.023,0,0,1-5.242-3.758,8.343,8.343,0,0,1-.334-1.947c0-1.2-.713-1.328-1.022-1.329-.664,0-1.038.555-1.115,1.71-.144,2.108-.221,3.929-.226,5.418,0,1.013.162,1.539,1.139,1.976a14.441,14.441,0,0,0,6.216,1.156,12.172,12.172,0,0,0,6.847-1.784A9.033,9.033,0,0,0,288.3,25.02C288.31,20.815,286.436,17.81,281.382,13.928Z"/><path d="M151.389,31.523a15.243,15.243,0,0,1-1.892-.166c-.649-.1-.9-.335-1.013-1.479-.148-1.756-.137-4.965-.123-9.028l.025-7.3c.022-6.312.026-7.447.107-8.764.085-1.509.414-1.681.931-1.784A5.756,5.756,0,0,1,150.48,2.9c1.118,0,1.242-.719,1.243-1.031,0-.355-.184-.951-1.429-.956-.823,0-1.893.034-2.852.064-.76.026-1.45.046-1.878.045-.52,0-1.322-.03-2.179-.061-1-.038-2.068-.078-2.863-.081-.383,0-1.549-.005-1.552.945,0,.312.118,1.036,1.236,1.04a4.68,4.68,0,0,1,1.251.149c.366.092.765.309.839,1.762.073,1.311.069,2.446.047,8.759l-.025,7.3c-.014,4.06-.025,7.266-.221,8.979-.129,1.313-.379,1.472-.658,1.53a5.238,5.238,0,0,1-1.084.135l-1.041,0a5.011,5.011,0,0,1-.913-.111c-.542-.118-1.982-.43-3.955-2.632-1.956-2.212-4.184-5.238-7-9.072l-1-1.363c3.441-3.086,4.923-5.91,4.935-9.36a7.966,7.966,0,0,0-2.87-6.19c-2.284-1.687-5.07-1.924-7.493-1.932-.593,0-1.6.026-2.636.054-1.069.027-2.159.055-2.829.052-.309,0-.859-.02-1.534-.045-1.095-.04-2.511-.093-3.779-.1-.973,0-1.471.33-1.473.988,0,.3.121.994,1.273,1a7.2,7.2,0,0,1,1.376.109c.853.2,1.11.458,1.182,1.8.07,1.308.066,2.446.044,8.759l-.025,7.3c-.013,3.785-.024,7.057-.217,8.753-.137,1.029-.292,1.681-.661,1.756a5.34,5.34,0,0,1-1.252.147c-1.149,0-1.243.724-1.243.946,0,.241.1,1.033,1.389,1.037.925,0,2.168-.038,3.178-.071.681-.02,1.257-.038,1.552-.037.193,0,.641.016,1.237.035,1.2.041,2.965.1,4.463.109,1.291,0,1.4-.787,1.4-1.028a.965.965,0,0,0-1.081-.954,16.567,16.567,0,0,1-1.812-.165c-.573-.084-.853-.355-.979-1.743-.184-1.709-.173-5-.16-8.807v-.287l3.064.087c.17,0,.184.015.218.061.274.338,1.033,1.5,1.841,2.738.615.947,1.3,2,1.947,2.955,2.3,3.407,3.778,5.318,5.492,6.3a7.986,7.986,0,0,0,4.454.889l4.894.017c.888,0,2.069-.035,3.084-.066.758-.023,1.422-.043,1.8-.042.4,0,1.019.02,1.768.046,1.188.041,2.709.094,4.278.1,1,0,1.358-.551,1.36-1.028C152.626,32.318,152.569,31.527,151.389,31.523Zm-25.834-20.54c-.012,3.589-1.3,5.131-2.065,5.727-.544.418-.89.573-2.377.568a11.35,11.35,0,0,1-2.66-.313.841.841,0,0,1-.016-.241L118.485,4.1a10.373,10.373,0,0,1,1.78-.1C122.24,4,125.574,5.482,125.555,10.983Z"/></svg>
                            <span class="visuallyhidden">Princess Cruises - come back new®</span>
                        </a>
                    </div>
                    <div class="global-header__container-right">
                        <ul class="global-header__container-right--list no-list-style">
                            <li class="global-header__container-right--list-item global-header__language-selector ${this.getAttribute('language') === 'false' ? 'hidden' : ''}" role="menubar" data-observed-attr="language">
                              <a href="#"
                                 class="invert-decoration global-header__language-selector-btn"
                                 data-nav-name="Language"
                                 data-page-section="Header"
                                 data-track="header"
                                 data-track-id="language-dropdown">
                                <svg id="globe" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                  <title>globe</title><path d="M12,1A11,11,0,1,0,23,12,11.013,11.013,0,0,0,12,1Zm9.975,10.5H17.483A16.633,16.633,0,0,0,16.7,6.952a14.393,14.393,0,0,0,2.991-1.338A9.943,9.943,0,0,1,21.975,11.5ZM18.989,4.86A13.791,13.791,0,0,1,16.358,6a12.04,12.04,0,0,0-2.265-3.78A9.99,9.99,0,0,1,18.989,4.86ZM7.517,11.5a15.5,15.5,0,0,1,.726-4.2A17.225,17.225,0,0,0,12,7.688a15.259,15.259,0,0,0,3.735-.466,15.5,15.5,0,0,1,.748,4.278Zm8.966,1a15.5,15.5,0,0,1-.726,4.2A17.225,17.225,0,0,0,12,16.312a15.274,15.274,0,0,0-3.736.466A15.539,15.539,0,0,1,7.517,12.5ZM12,2c.808,0,2.34,1.663,3.39,4.274A14.206,14.206,0,0,1,12,6.688a16.233,16.233,0,0,1-3.419-.346C9.631,3.69,11.184,2,12,2Zm-2.092.224A12.128,12.128,0,0,0,7.61,6.09,10.222,10.222,0,0,1,4.958,4.909,9.989,9.989,0,0,1,9.908,2.224ZM4.274,5.66a10.731,10.731,0,0,0,3,1.381A16.6,16.6,0,0,0,6.517,11.5H2.025A9.947,9.947,0,0,1,4.274,5.66ZM2.025,12.5H6.517A16.626,16.626,0,0,0,7.3,17.048a14.393,14.393,0,0,0-2.991,1.338A9.945,9.945,0,0,1,2.025,12.5Zm2.986,6.64A13.791,13.791,0,0,1,7.642,18a12.022,12.022,0,0,0,2.266,3.78A9.988,9.988,0,0,1,5.011,19.14ZM12,22c-.808,0-2.34-1.663-3.39-4.274A14.206,14.206,0,0,1,12,17.312a16.233,16.233,0,0,1,3.419.346C14.369,20.31,12.815,22,12,22Zm2.093-.224a12.146,12.146,0,0,0,2.3-3.866,10.222,10.222,0,0,1,2.652,1.181A9.99,9.99,0,0,1,14.093,21.776Zm5.633-3.436a10.745,10.745,0,0,0-3-1.381,16.6,16.6,0,0,0,.761-4.459h4.492A9.947,9.947,0,0,1,19.726,18.34Z"></path>
                                </svg>
                                Language
                              </a>
                              <div class="global-header__language-dropdown hidden-sm-down hidden" aria-hidden="true">
                                <a href="#" class="global-header__language-link${this.pclLang === 'en' ? ' active' : ''}" lang="en" data-language-select="en" data-track="header" data-track-id="English" tabindex="0" aria-selected="true">English</a>
                                <a href="#" class="global-header__language-link${this.pclLang === 'es' ? ' active' : ''}" lang="es-la" data-language-select="es" data-track="header" data-track-id="Spanish" tabindex="0">Español</a>
                                <a href="#" class="global-header__language-link${this.pclLang === 'jp' ? ' active' : ''}" lang="ja-jp" data-language-select="jp" data-track="header" data-track-id="Japanese" tabindex="0">日本語<span class="visuallyhidden">Japanese</span></a>
                              </div>
                            </li>
                            <li class="global-header__container-right--list-item ${this.getAttribute('special-offers') === 'false' ? 'hidden' : ''}" data-observed-attr="special-offers">
                                ${isGuestAuthenticated ?
                                    `` :
                                    `<a href="${$bookURL}/captaincircle/specialOfferRegistration.page?track=header&amp;trackId=special-offers"
                                       class="invert-decoration special-offers-sign-up global-mfp-modal"
                                       data-nav-name="Special Offers Sign Up"
                                       data-page-section="Header"
                                       data-track="header"
                                       data-track-id="special-offers">
                                       <svg id="email" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>email</title><path d="M12.9,13.8a1.613,1.613,0,0,1-.9.3,1.4,1.4,0,0,1-.9-.3L1,6.8V18.5A1.538,1.538,0,0,0,2.5,20h19A1.538,1.538,0,0,0,23,18.5V6.8Z"/><path d="M12,12,22.7,4.5A1.656,1.656,0,0,0,21.5,4H2.5a1.425,1.425,0,0,0-1.2.6Z"/></svg>
                                       Special Offers Sign Up
                                    </a>`
                                }
                            </li>
                            ${cruiseDealslocalizedLinkUrl && cruiseDealslocalizedLinkTitle ?  `
                                <li class="global-header__container-right--list-item ${this.getAttribute('cruise-deals') === 'false' ? 'hidden' : ''}" data-observed-attr="cruise-deals">
                                    <a href="${$wwwURL}${cruiseDealslocalizedLinkUrl}"
                                       class="invert-decoration"
                                       data-page-section="Header"
                                       data-track="header"
                                       data-track-id="cruise-deals"
                                       data-nav-name="Cruise Deals"
                                       data-us-url="${$wwwURL}${cruiseDealslocalizedLinkTitle}/">
                                       <svg id="icon-tag" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>tag</title><path d="M23,10.814V2.537A1.537,1.537,0,0,0,21.463,1H13.186a1.533,1.533,0,0,0-1.08.445c-.267.276-10.678,10.678-10.678,10.678a1.462,1.462,0,0,0,0,2.066l8.381,8.382a1.463,1.463,0,0,0,2.067,0L22.523,11.923A1.525,1.525,0,0,0,23,10.814M15.248,8.752a2.126,2.126,0,1,1,3.006,0,2.128,2.128,0,0,1-3.006,0"/></svg>
                                       ${cruiseDealslocalizedLinkTitle}
                                    </a>
                                </li>
                            ` : ''}
                            <li class="global-header__container-right--list-item my-account-section col-xs-pad-5-right col-lg-pad-15-right ${this.getAttribute('my-account') === 'false' ? 'hidden' : ''}" data-observed-attr="my-account">
                                ${isGuestAuthenticated ? `<a class="invert-decoration my-account"
                                    href="${$bookURL}/captaincircle/myPrincess.page"
                                    data-page-section="Header"
                                    data-track="header"
                                    data-track-id="my-account">
                                    My Account
                                    <div class="pipe"></div>
                                </a>
                                <a class="invert-decoration my-account notification"
                                    href="${$wwwURL}/cruise-vacation-planning-dashboard/home.do"
                                    data-page-section="Header"
                                    data-track="header"
                                    data-track-id="saved-cruise">
                                    Saved
                                    <div class="pipe"></div>
                                </a>` : `<a class="invert-decoration my-account my-account-login global-mfp-modal ownid hidden"
                                    href="${$wwwURL}/my-princess/ownid/${this.getLoginSrc()}"
                                    data-page-section="Header"
                                    data-track="header"
                                    data-track-id="my-account">
                                    <svg id="icon-user" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>user</title><path d="M3.589,17.77c1.634-.683,3.336-1.234,5.026-1.756.8-.247.821-.51.594-1.407-.19-.751-.595-1.422-.766-2.187-.259-1.159-1.015-2.08-1.031-3.357-.007-.651.21-1.168.163-1.845-.121-1.719-.4-3.247.865-4.69A4.817,4.817,0,0,1,11.838,1c3.1-.166,5.879,1.776,5.407,5.127A7.826,7.826,0,0,0,17.1,7.979a8.016,8.016,0,0,1,.18,1.2,5.39,5.39,0,0,1-.544,2.118c-.13.261-.3.488-.407.748-.167.425-.209.93-.369,1.368a4.944,4.944,0,0,0-.393,1.819c0,.9.6.775,1.4,1.038a20.494,20.494,0,0,1,4.531,1.7c.953.615.756,1.752.756,2.741,0,1.15.172,2.258-1.3,2.29-2.811.062-5.63,0-8.442,0-2.935,0-5.88.077-8.814,0-1.328-.035-1.306-.892-1.308-1.948C2.388,19.749,2.18,18.426,3.589,17.77Z"/></svg>
                                    Log In <div class="pipe"></div>
                                </a>
                                <a class="invert-decoration my-account my-account-login global-mfp-modal"
                                    href="${$wwwURL}/my-princess/login/${this.getLoginSrc()}"
                                    data-page-section="Header"
                                    data-track="header"
                                    data-track-id="my-account">
                                    <svg id="icon-user" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>user</title><path d="M3.589,17.77c1.634-.683,3.336-1.234,5.026-1.756.8-.247.821-.51.594-1.407-.19-.751-.595-1.422-.766-2.187-.259-1.159-1.015-2.08-1.031-3.357-.007-.651.21-1.168.163-1.845-.121-1.719-.4-3.247.865-4.69A4.817,4.817,0,0,1,11.838,1c3.1-.166,5.879,1.776,5.407,5.127A7.826,7.826,0,0,0,17.1,7.979a8.016,8.016,0,0,1,.18,1.2,5.39,5.39,0,0,1-.544,2.118c-.13.261-.3.488-.407.748-.167.425-.209.93-.369,1.368a4.944,4.944,0,0,0-.393,1.819c0,.9.6.775,1.4,1.038a20.494,20.494,0,0,1,4.531,1.7c.953.615.756,1.752.756,2.741,0,1.15.172,2.258-1.3,2.29-2.811.062-5.63,0-8.442,0-2.935,0-5.88.077-8.814,0-1.328-.035-1.306-.892-1.308-1.948C2.388,19.749,2.18,18.426,3.589,17.77Z"/></svg>
                                    Log In <div class="pipe"></div>
                                </a>`
            }

                                ${isGuestAuthenticated ? `
                                    <a class="invert-decoration my-account-logout-btn legacy"
                                        href="#"
                                        data-page-section="Header"
                                        data-track="header"
                                        data-track-id="log-out">
                                        Log Out <div class="pipe"></div>
                                    </a>
                                    <a class="invert-decoration my-account-logout-btn ownid hidden"
                                        href="#"
                                        data-page-section="Header"
                                        data-track="header"
                                        data-track-id="log-out">
                                        Log Out <div class="pipe"></div>
                                    </a>`: `<a class="invert-decoration header-action" 
                                    href="${$wwwURL}/my-princess/register/"
                                    data-page-section="Header" 
                                    data-track="header" 
                                    data-track-id="register">
                                    Create account
                                </a>`
            }
                            </li>
                            ${this.getAttribute('search') === 'false' ? '' :
                            `<li class="global-header__container-right--list-item global-header__search col-xs-pad-5-right ${this.getAttribute('search') === 'false' ? 'hidden' : ''}" data-observed-attr="search">
                                <a class="global-header__search-btn" data-page-section="Header" data-track="header" data-track-id="site-search" data-page-section="Header" role="button" aria-haspopup="true" aria-expanded="false" tabindex="0">
                                    <svg id="search" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>search</title><path d="M21.89,20.348,16.069,14.2a7.89,7.89,0,0,0,1.957-5.165A8.107,8.107,0,0,0,9.852,1,8.107,8.107,0,0,0,1.679,9.039a8.106,8.106,0,0,0,8.173,8.04,8.2,8.2,0,0,0,3.735-.926l6.023,6.356a1.571,1.571,0,1,0,2.28-2.161ZM4.822,9.039a4.969,4.969,0,0,1,5.03-4.9,4.97,4.97,0,0,1,5.031,4.9,4.971,4.971,0,0,1-5.031,4.9A4.97,4.97,0,0,1,4.822,9.039Z"/></svg>
                                </a>
                                <div class="global-header__search-dropdown hidden-sm-down hidden" aria-hidden="true">
                                    <div class="global-header__search-dropdown-content container">
                                        <div class="global-header__searchbar">
                                                <label for="header-site-search-field-desktop" class="visuallyhidden">Search princess.com</label>
                                                <input type="text" class="global-header__searchbar-input" placeholder="Search Princess.com" id="header-site-search-field-desktop">
                                                <button class="global-header__searchbar-button">
                                                     <svg id="searchbar-btn" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>search</title><path d="M21.89,20.348,16.069,14.2a7.89,7.89,0,0,0,1.957-5.165A8.107,8.107,0,0,0,9.852,1,8.107,8.107,0,0,0,1.679,9.039a8.106,8.106,0,0,0,8.173,8.04,8.2,8.2,0,0,0,3.735-.926l6.023,6.356a1.571,1.571,0,1,0,2.28-2.161ZM4.822,9.039a4.969,4.969,0,0,1,5.03-4.9,4.97,4.97,0,0,1,5.031,4.9,4.971,4.971,0,0,1-5.031,4.9A4.97,4.97,0,0,1,4.822,9.039Z"/></svg>
                                                </button>
                                        </div>
                                        <div class="global-header__suggested-links">
                                            <h3>Suggested Links</h3>
                                            <ul>
                                                <li><a class="invert-decoration col-xs-pad-5-top col-xs-pad-5-bottom" href="${$wwwURL}/learn/faq/pre-cruise/prepare-for-your-cruise/">Pre-Cruise FAQ</a></li>
                                                <li><a class="invert-decoration col-xs-pad-5-top col-xs-pad-5-bottom" href="${$wwwURL}/learn/faq/onboard/onboard-experience/">Onboard FAQ</a></li>
                                            </ul>
                                            <ul>
                                                <li><a class="invert-decoration col-xs-pad-5-top col-xs-pad-5-bottom" href="${$wwwURL}/learn/faq/post-cruise/disembarkation/">Post-Cruise FAQ</a></li>
                                                <li><a class="invert-decoration col-xs-pad-5-top col-xs-pad-5-bottom" href="${$wwwURL}/learn/faq/">Cruisetours FAQ</a></li>
                                            </ul>
                                        </div>
                                        <button class="global-header__search-close" aria-label="Close Search" tabindex="0">
                                          <svg viewBox="0 0 24 24" id="icon-open-close"><path fill-rule="evenodd" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.2,16.12a.75.75,0,1,1-1.06,1.06L12,13.06,6.88,18.19a.75.75,0,0,1-1.06-1.06L10.95,12,5.82,6.87A.75.75,0,0,1,6.88,5.81L12,10.94l5.13-5.13a.75.75,0,1,1,1.06,1.06L13.07,12Z"></path></svg>
                                          </button>
                                    </div>
                                </div>
                            </li>`
                            }

                            <li class="global-header__container-right--list-item">
                                <span class="hidden hidden-md-down custom-message-text ${this.getAttribute('custom-message') === 'false' ? 'hidden' : ''}" data-observed-attr="custom-message"></span>
                            </li>
                           
                            <li class="global-header__container-right--list-item global-header__menu hidden-md-up">
                                 <a tabindex="0" class="global-header__menu-btn col-xs-pad-5-top col-xs-pad-5-bottom"
                                         role="button"
                                         aria-haspopup="true"
                                         aria-expanded="false">
                                    <div class="icon">
                                        <span class="top"></span>
                                        <span class="bottom"></span>
                                    </div>
                                    <span>Menu</span>
                                 </a>
                            </li>
                        </ul>
                    </div>
                        <div class="global-header__container-cruise-ship hidden-md-up">
                            <a class="invert-decoration"
                            href="${$wwwURL}${this.cruiseButtonHref}">
                                <svg id="icon-ship" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>ship</title><path d="M23,11.634a7.8,7.8,0,0,1-.872-.587c-.079.051-.3.5-.436.587-.428-.136-2.091-.221-3.488-.587-.451.356-1.152.068-1.609.1s-.9.008-1.352.008l0-.075c1.544,0,2.091-.038,2.091-.038a6.413,6.413,0,0,0-.569-.7H13.547v-.02H16.2c.04-.187.074-.341.122-.562L15.578,9c.073-.187.143-.36.212-.534l-.054-.048-.435.823c-.128-.25-.233-.451-.355-.689a.9.9,0,0,1-.956-.63c-.012-.207-.024-.429-.036-.651l-.1.008c-.014.264-.028.529-.047.9-.255-.07-.531-.036-.714-.216a1.764,1.764,0,0,0-1.452-.47,7.187,7.187,0,0,1-.928-.016,2.9,2.9,0,0,1-.526-.144c-.06-.278-.1-.475-.181-.84-.121.408-.2.662-.269.9l-.488.276a.934.934,0,0,1-.5,1.06c-.246.163-.511.32-.794.5-.036-.35-.554-.832-.581.286-.706.675-1.387,1.344-2.082,1.98-.637.443-1.726,1.132-1.726,1.132a.739.739,0,0,0,.015.078c1.338-.579,5.9-3.193,7.679-4.036.008.554-.253.542-.425.629-2.409,1.235-7.3,3.652-8.873,4.569L2,14.03q4-2.011,7.988-4.024l.235.327,2.225-.744-.207.65c.032.012.389.075.6.149-.121.276-.278.346-.239.6-.228.019-.446.372-.684.056a58.018,58.018,0,0,0-5.511,2.123C5.359,13.571,1.7,14.8,1.337,14.907c-.2.7-.743,2.515.3,2.6.92-.006,11.264-.076,17.006,0,.388.005.737-.141.435-.588-.43-.5-1.267.123-.871-.587a11.208,11.208,0,0,1,.871-1.175A17.657,17.657,0,0,1,23,11.634ZM9.436,8.267,9.4,8.155,9.758,7.9l.052.139ZM9.049,13.8l-.739.221c-.006-.078-.012-.158-.018-.238C8.528,13.627,8.763,13.457,9.049,13.8Zm-4.317.752c.566-.155,1.135-.295,1.7-.443.412-.107.823-.227,1.237-.315.091-.019.194.074.291.116l0,.15L2.779,15.309l-.024-.2C3.414,14.927,4.072,14.736,4.732,14.556Zm-3.3,1.6c.276-.391.314.279.5.261C1.736,16.484,1.522,16.638,1.433,16.156Zm.356-.628L1.773,15.4l.764-.207.017.155Zm1.492.79h-.7v-.057H3.3Zm.125-.516h-.5l0-.078h.5C3.409,15.75,3.408,15.776,3.406,15.8Zm12.745-1.711C15.323,14.215,4.106,15.7,3.876,15.7l0-.16,12.652-1.975C16.525,14.108,16.313,14.066,16.151,14.091Z" fill-rule="evenodd"/></svg>
                                Cruises
                            </a>
                        </div>
                </div>
            </header>
            <div class="global-header__nav-container">
                    <div class="global-header__account-section-mobile hidden-md-up">
                        <ul>
                            <li class="global-header__container-right--list-item my-account-section">
                                ${isGuestAuthenticated ? `<a class="invert-decoration my-account"
                                    href="${$bookURL}/captaincircle/myPrincess.page"
                                    data-page-section="Header" 
                                    data-track="header" 
                                    data-track-id="my-account">
                                    My Account <div class="pipe"></div>
                                </a>
                                <a class="invert-decoration my-account notification"
                                    href="${$wwwURL}/cruise-vacation-planning-dashboard/home.do"
                                    data-page-section="Header" 
                                    data-track="header" 
                                    data-track-id="saved-cruise">
                                    Saved <div class="pipe"></div>
                                </a>` : `<a class="invert-decoration my-account my-account-login global-mfp-modal ownid hidden" 
                                    href="${$wwwURL}/my-princess/ownid/${this.getLoginSrc()}"
                                    data-page-section="Header" 
                                    data-track="header" 
                                    data-track-id="my-account">
                                    <svg id="icon-user" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>user</title><path d="M3.589,17.77c1.634-.683,3.336-1.234,5.026-1.756.8-.247.821-.51.594-1.407-.19-.751-.595-1.422-.766-2.187-.259-1.159-1.015-2.08-1.031-3.357-.007-.651.21-1.168.163-1.845-.121-1.719-.4-3.247.865-4.69A4.817,4.817,0,0,1,11.838,1c3.1-.166,5.879,1.776,5.407,5.127A7.826,7.826,0,0,0,17.1,7.979a8.016,8.016,0,0,1,.18,1.2,5.39,5.39,0,0,1-.544,2.118c-.13.261-.3.488-.407.748-.167.425-.209.93-.369,1.368a4.944,4.944,0,0,0-.393,1.819c0,.9.6.775,1.4,1.038a20.494,20.494,0,0,1,4.531,1.7c.953.615.756,1.752.756,2.741,0,1.15.172,2.258-1.3,2.29-2.811.062-5.63,0-8.442,0-2.935,0-5.88.077-8.814,0-1.328-.035-1.306-.892-1.308-1.948C2.388,19.749,2.18,18.426,3.589,17.77Z"/></svg>
                                    Log In <div class="pipe"></div>
                                </a>
                                <a class="invert-decoration my-account my-account-login global-mfp-modal" 
                                    href="${$wwwURL}/my-princess/login/${this.getLoginSrc()}"
                                    data-page-section="Header" 
                                    data-track="header"
                                    data-track-id="my-account">
                                    <svg id="icon-user" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>user</title><path d="M3.589,17.77c1.634-.683,3.336-1.234,5.026-1.756.8-.247.821-.51.594-1.407-.19-.751-.595-1.422-.766-2.187-.259-1.159-1.015-2.08-1.031-3.357-.007-.651.21-1.168.163-1.845-.121-1.719-.4-3.247.865-4.69A4.817,4.817,0,0,1,11.838,1c3.1-.166,5.879,1.776,5.407,5.127A7.826,7.826,0,0,0,17.1,7.979a8.016,8.016,0,0,1,.18,1.2,5.39,5.39,0,0,1-.544,2.118c-.13.261-.3.488-.407.748-.167.425-.209.93-.369,1.368a4.944,4.944,0,0,0-.393,1.819c0,.9.6.775,1.4,1.038a20.494,20.494,0,0,1,4.531,1.7c.953.615.756,1.752.756,2.741,0,1.15.172,2.258-1.3,2.29-2.811.062-5.63,0-8.442,0-2.935,0-5.88.077-8.814,0-1.328-.035-1.306-.892-1.308-1.948C2.388,19.749,2.18,18.426,3.589,17.77Z"/></svg>
                                    Log In <div class="pipe"></div>
                                </a>`
            }
                                
                                ${isGuestAuthenticated ? `
                                <a class="invert-decoration my-account-logout-btn legacy"
                                    href="#"
                                    data-page-section="Header" 
                                    data-track="header" 
                                    data-track-id="log-out">
                                    Log out <div class="pipe"></div>
                                </a> 
                                <a class="invert-decoration my-account-logout-btn ownid hidden"
                                    href="#"
                                    data-page-section="Header" 
                                    data-track="header" 
                                    data-track-id="log-out">
                                    Log out <div class="pipe"></div>
                                </a>
                                ` : `<a class="invert-decoration" 
                                    href="${$wwwURL}/my-princess/register/"
                                    data-page-section="Header" 
                                    data-track="header" 
                                    data-track-id="register">
                                    Create account
                                </a>`
            }
                            </li>
                        </ul>
                    </div>
                    <div class="global-header__search-mobile hidden-md-up">
                        <div class="global-header__searchbar mobile">
                                <label for="header-site-search-field-mobile" class="visuallyhidden">Search Princess.com</label>
                                <input type="text" class="global-header__searchbar-input-mobile" placeholder="Search Princess.com" id="header-site-search-field-mobile">
                                <button class="global-header__searchbar-button-mobile">
                                     <svg id="searchbar-btn" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>search</title><path d="M21.89,20.348,16.069,14.2a7.89,7.89,0,0,0,1.957-5.165A8.107,8.107,0,0,0,9.852,1,8.107,8.107,0,0,0,1.679,9.039a8.106,8.106,0,0,0,8.173,8.04,8.2,8.2,0,0,0,3.735-.926l6.023,6.356a1.571,1.571,0,1,0,2.28-2.161ZM4.822,9.039a4.969,4.969,0,0,1,5.03-4.9,4.97,4.97,0,0,1,5.031,4.9,4.971,4.971,0,0,1-5.031,4.9A4.97,4.97,0,0,1,4.822,9.039Z"/></svg>
                                </button>
                        </div>
                    </div>
            </div>
            <div class="global-header__nav-container-overlay hidden-md-up"></div>
        `;
    }

    linkStylesheet(url) {
        return new Promise((resolve, reject) => {
            let link = document.createElement('link');
            link.type = 'text/css';
            link.rel = 'stylesheet';
            link.onload = () => resolve();
            link.onerror = () => reject();
            link.href = url;

            let headScript = document.querySelector('script');
            headScript.parentNode.insertBefore(link, headScript);
        });
    }
}

if (!window.customElements.get('pcl-global-header')) {
    customElements.define("pcl-global-header", PclGlobalHeader);
}
